export default {
  subtitle:
    'We versturen de geselecteerde gebeurtenissen via POST naar je endpoints, ondertekend met het endpoint-geheim.',
  regenerate_confirm: 'Nieuw ondertekeningsgeheim genereren? Het huidige geheim werkt direct niet meer.',
  delete_confirm: 'Dit endpoint verwijderen? Het ontvangt dan geen gebeurtenissen meer.',
  consecutive_failures: '{{count}} opeenvolgende mislukkingen',
  columns: {
    url: 'Endpoint',
    events: 'Gebeurtenissen',
    status: 'Status',
    secret: 'Geheim',
  },
  statuses: {
    active: 'Actief',
    disabled: 'Uitgeschakeld',
    auto_disabled: 'Automatisch uitgeschakeld',
  },
  buttons: {
    create: 'Endpoint toevoegen',
    edit: 'Bewerken',
    regenerate_secret: 'Nieuw geheim',
    delete: 'Verwijderen',
  },
  toasts: {
    load_error: 'Kan de webhook-endpoints niet laden.',
    error: 'Er is iets misgegaan. Probeer het opnieuw.',
    deleted: 'Endpoint verwijderd.',
  },
};
